
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchOrders } from "../redux/actions/orderActions";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import Loader from "../components/shared/Loader";
import OrderModal from "../components/Order/OrderModal";
import { FcInfo } from "react-icons/fc";
// import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const Order = () => {
  const dispatch = useDispatch();
  const { orders, loading, error } = useSelector((state) => state.order);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [deliveryStatusFilter, setDeliveryStatusFilter] = useState("");

  useEffect(() => {
    dispatch(fetchOrders());
  }, [dispatch]);

  const filteredOrders = orders.filter((order) => {
    const matchesSearch =
      !search ||
      (order.customerName || "").toLowerCase().includes(search.toLowerCase()) ||
      (order.customerEmail || "").toLowerCase().includes(search.toLowerCase());
    const matchesStatus = !statusFilter || order.paymentStatus === statusFilter;
    const matchesDeliveryStatus = !deliveryStatusFilter || order.deliveryStatus === deliveryStatusFilter;
    const orderDateStr = new Date(order.paymentDate).toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    const matchesFrom = !dateFrom || orderDateStr >= dateFrom;
    const matchesTo = !dateTo || orderDateStr <= dateTo;
    return matchesSearch && matchesStatus && matchesDeliveryStatus && matchesFrom && matchesTo;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

  const handleNext = () => currentPage < totalPages && setCurrentPage(prev => prev + 1);
  const handlePrevious = () => currentPage > 1 && setCurrentPage(prev => prev - 1);

  return (
    <div className="w-full min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="bg-white rounded-xl shadow-sm pb-6">
        <h1 className="p-6 text-2xl font-bold text-gray-800 border-b border-gray-200">
          Order Management
        </h1>

        <div className="px-6 pt-4 flex flex-wrap gap-3 items-end">
          <input
            type="text"
            placeholder="Search by name or email"
            value={search}
            onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
            className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black"
          />
          <select
            value={statusFilter}
            onChange={(e) => { setStatusFilter(e.target.value); setCurrentPage(1); }}
            className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black"
          >
            <option value="">All Statuses</option>
            <option value="pending">Pending</option>
            <option value="paid">Paid</option>
          </select>
          <select
            value={deliveryStatusFilter}
            onChange={(e) => { setDeliveryStatusFilter(e.target.value); setCurrentPage(1); }}
            className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black"
          >
            <option value="">All Delivery Status</option>
            <option value="Ordered">Ordered</option>
            <option value="Packed">Packed</option>
            <option value="Shipped">Shipped</option>
            <option value="Delivered">Delivered</option>
            <optgroup label="Return">
              <option value="Return Initiated">Return Initiated</option>
              <option value="Return Accepted">Return Accepted</option>
              <option value="Return Picked">Return Picked</option>
              <option value="Return Completed">Return Completed</option>
            </optgroup>
            <optgroup label="Replacement">
              <option value="Replacement Initiated">Replacement Initiated</option>
              <option value="Replacement Accepted">Replacement Accepted</option>
              <option value="Replacement Shipped">Replacement Shipped</option>
              <option value="Replacement Completed">Replacement Completed</option>
            </optgroup>
          </select>
          <div className="flex items-center gap-2">
            <label className="text-sm text-gray-600">From:</label>
            <input
              type="date"
              value={dateFrom}
              onChange={(e) => { setDateFrom(e.target.value); setCurrentPage(1); }}
              className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>
          <div className="flex items-center gap-2">
            <label className="text-sm text-gray-600">To:</label>
            <input
              type="date"
              value={dateTo}
              onChange={(e) => { setDateTo(e.target.value); setCurrentPage(1); }}
              className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>
          {(search || statusFilter || deliveryStatusFilter || dateFrom || dateTo) && (
            <button
              onClick={() => { setSearch(""); setStatusFilter(""); setDeliveryStatusFilter(""); setDateFrom(""); setDateTo(""); setCurrentPage(1); }}
              className="text-sm text-red-500 hover:text-red-700 underline"
            >
              Clear Filters
            </button>
          )}
        </div>

        {loading && <Loader className="py-12" />}

        {error && (
          <div className="p-6 text-red-600 bg-red-50 mx-6 mt-4 rounded-lg">
            Error: {error}
          </div>
        )}

        {!loading && !error && (
          <>
            <div className="overflow-hidden px-6">
              <Table className="w-full mt-4">
               
 <Thead className="bg-black text-white">
                  <Tr className="bg-black text-white-50 text-left">
                    <Th className="px-4 py-3 text-sm font-semibold text-gray-600">#</Th>
                    <Th className="px-4 py-3 text-sm font-semibold text-gray-600">Customer</Th>
                    <Th className="px-4 py-3 text-sm font-semibold text-gray-600">Amount</Th>
                    <Th className="px-4 py-3 text-sm font-semibold text-gray-600">Payment Status</Th>
                    <Th className="px-4 py-3 text-sm font-semibold text-gray-600">Delivery Status</Th>
                    <Th className="px-4 py-3 text-sm font-semibold text-gray-600">Payment Date</Th>
                    <Th className="px-4 py-3 text-sm font-semibold text-gray-600">Details</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {currentItems.map((order, index) => (
                    <Tr 
                      key={order.orderId}
                      className="border-t border-gray-100 hover:bg-gray-50 transition-colors"
                    >
                      <Td className="px-4 py-3 text-sm text-gray-700">
                        {indexOfFirstItem + index + 1}
                      </Td>
                      <Td className="px-4 py-3 text-sm text-gray-700">
                        <div className="flex flex-col">
                          <span className="font-medium">{order.customerName || 'N/A'}</span>
                          <span className="text-gray-500 text-xs">{order.customerEmail}</span>
                        </div>
                      </Td>
                      <Td className="px-4 py-3 text-sm font-medium text-gray-700">
                        ₹{order.totalAmount}
                      </Td>
                      <Td className="px-4 py-3">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          order.paymentStatus === 'pending' 
                            ? 'bg-blue-100 text-blue-800'
                            : 'bg-green-100 text-green-800'
                        }`}>
                          {order.paymentStatus}
                        </span>
                      </Td>
                      <Td className="px-4 py-3">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          { Ordered: 'bg-yellow-100 text-yellow-800', Packed: 'bg-orange-100 text-orange-800', Shipped: 'bg-blue-100 text-blue-800', Delivered: 'bg-green-100 text-green-800', 'Return Initiated': 'bg-red-100 text-red-800', 'Return Accepted': 'bg-red-100 text-red-800', 'Return Picked': 'bg-red-100 text-red-800', 'Return Completed': 'bg-red-100 text-red-800', 'Replacement Initiated': 'bg-purple-100 text-purple-800', 'Replacement Accepted': 'bg-purple-100 text-purple-800', 'Replacement Shipped': 'bg-purple-100 text-purple-800', 'Replacement Completed': 'bg-purple-100 text-purple-800' }[order.deliveryStatus] || 'bg-gray-100 text-gray-800'
                        }`}>
                          {order.deliveryStatus || 'N/A'}
                        </span>
                      </Td>
                      <Td className="px-4 py-3 text-sm text-gray-600">
                        {new Date(order.paymentDate).toLocaleDateString('en-IN', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric'
                        })}
                      </Td>
                      <Td className="px-4 py-3">
                        <button
                          onClick={() => setSelectedOrder(order)}
                          className="flex items-center text-gray-600 hover:text-blue-600 transition-colors"
                        >
                          <FcInfo className="w-5 h-5 mr-1" />
                          <span className="text-sm">View</span>
                        </button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </div>



<div className="flex justify-between items-center mt-4">
  <button
    onClick={handlePrevious}
    disabled={currentPage === 1}
    className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 disabled:opacity-50 transition duration-300"
  >
    Previous
  </button>

  <p className="text-gray-700">
    Page {currentPage} of {totalPages}
  </p>

  <button
    onClick={handleNext}
    disabled={currentPage === totalPages}
    className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 disabled:opacity-50 transition duration-300"
  >
    Next
  </button>
</div>


          </>
        )}
      </div>

      {/* Conditionally render the modal */}
      {selectedOrder && (
        <OrderModal 
          order={selectedOrder} 
          onClose={() => setSelectedOrder(null)} 
        />
      )}
    </div>
  );
};

export default Order;